import { setAuthTokens } from "./tokens";
import type { Tokens } from "./tokenSchema";
import { setAuthLoading } from "../../../redux/reducers/authReducers";
import { setChannel } from "../../../redux/reducers/channel";
import { setMarketPlace } from "../../../redux/reducers/marketPlace";
import { setCurrentUser } from "../../../redux/reducers/userReducer";
import type { AppDispatch } from "../../../redux/store";
import { apiClient } from "../../../zodios/client";
import i18n from "../../../i18n";
import { isPersistedLanguage } from "../../../i18n/languages";

export const tokenLogin = async (tokens: Tokens | undefined | null, dispatch: AppDispatch) => {
  if (tokens) {
    dispatch(setAuthLoading(true));

    try {
      dispatch(setAuthTokens(tokens));

      const userProfileRes = await apiClient.getUserProfile();

      dispatch(setCurrentUser(userProfileRes));

      // Account-wide language preference overrides the local `i18nextLng` cache on sign-in.
      const language = userProfileRes.language;
      if (language && isPersistedLanguage(language) && language !== i18n.resolvedLanguage) {
        void i18n.changeLanguage(language);
      }
      dispatch(setChannel(userProfileRes.channel.toLowerCase()));
      localStorage.setItem("channel", userProfileRes.channel.toLowerCase());

      const orgId = userProfileRes.organization_id;
      let marketplace = userProfileRes.default_marketplace?.[orgId];
      if (!marketplace) {
        const sellerInfo = await apiClient.getSellerInfo();
        marketplace = sellerInfo.fallback_default_marketplace || "USA";
      }
      dispatch(setMarketPlace(marketplace));
      localStorage.setItem("Marketplace", marketplace);
    } finally {
      dispatch(setAuthLoading(false));
    }
  }
};
